import React from "react"

// Components
import "./style.css"

const MediumSpacer = () => {
    return <div className="medium-spacer" />
}

export default MediumSpacer



// WEBPACK FOOTER //
// ./src/components/MediumSpacer/index.js